module.exports = __webpack_public_path__ + "static/img/up-f.f836a25e.webp";